import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import { DEFAULT_PRIME_INPUT_TEXT_MAX_LENGTH } from './prime';

@Directive({
  selector: 'input[pInputText]',
  standalone: true,
})
export class PrimeInputTextDefaultMaxlengthDirective implements OnInit {
  private readonly elementRef =
    inject<ElementRef<HTMLInputElement>>(ElementRef);

  public ngOnInit(): void {
    const input = this.elementRef.nativeElement;

    if (input.maxLength !== -1) {
      return;
    }

    input.maxLength = DEFAULT_PRIME_INPUT_TEXT_MAX_LENGTH;
  }
}
